import { memo, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import check from 'check-types';

import { Alert, Panel } from '@sdflc/ui';
import { STATUSES } from '@sdflc/utils';

import { LocalizationContext } from '../../../contexts';
import { BankAccountItem } from './BankAccountItem';

const fakeBankDetails = Array.from({ length: 2 }).map((_, idx) => ({
  id: idx,
  countryId: 'CA',
  userLocation: '12 Main Street, Calgary, AB, T2W 8Y0',
  institutionNumber: '000',
  transitNumber: '00000',
  accountNumber: '1234567890',
  status: STATUSES.ACTIVE,
}));

const BankAccountsList = memo((props) => {
  const { onClickAction, list, items, listOp, removingOps } = props;
  const { getText } = useContext(LocalizationContext);

  useEffect(() => {
    // Load bank accounts if they were not yet loaded

    if (!listOp.called && check.function(list)) {
      list({
        filter: {},
        params: {},
      });
    }
  }, [list, listOp]);

  if (
    listOp.called &&
    !listOp.result.isInProgress() &&
    listOp.result.didFail()
  ) {
    return <Alert variant='danger'>{listOp.result.getErrorSummary()}</Alert>;
  }

  const items2use = listOp.result?.isInProgress() ? fakeBankDetails : items;

  return (
    <Panel mt={2} p={1} overflow='initial'>
      {items2use.map((item) => {
        return (
          <BankAccountItem
            key={item.id}
            value={item}
            onClickAction={onClickAction}
            loading={listOp.result?.isInProgress()}
            removingResult={removingOps[item.id]?.result}
          />
        );
      })}
      {!listOp.result?.isInProgress() && items.length === 0 && (
        <Alert variant='default'>{getText('pages.bankAccounts.noItems')}</Alert>
      )}
    </Panel>
  );
});

BankAccountsList.displayName = 'BankAccountsList';

BankAccountsList.propTypes = {
  onClickAction: PropTypes.func,
  list: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  listOp: PropTypes.any,
  removingOps: PropTypes.any,
};

BankAccountsList.defaultProps = {
  onClickAction: null,
};

export { BankAccountsList };
